import { Hidden, Tabs } from '@mui/material';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InfoBarWrapper } from '../../../../../global/components/layout/info-bar-wrapper';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { genericStepperStyles } from '../../../../../global/constants/theme/styles/components/generic-stepper';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { AccountInfoRoutes } from '../../../../account-info/constants/routes';
import { NewHireProps } from '../../../models/arc-epi-props';
import { NewHireEnrollmentStep } from '../models/new-hire-enrollment-models';
import { NewHireEnrollmentRoutes } from '../models/new-hire-routes';
import { setCurrentNewHireEnrollmentStep } from '../slice/new-hire-enrollment-slices';
import { PersonalInfoState } from '../../../../account-info/features/personal-info/personal-info-models';
import { NameClientNumber } from '../../../../../global/components/name-client-number';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { DemographicsContext } from '../../../../../global/models/demographics-model';
import { isNepEnrollment } from '../hooks/isNepEnrollment';
import { HoursIncreaseEventType } from '../../../constants/constant-strings';


interface Props {
	basePath: string;
	hideSteps: boolean;
	hideAll?: boolean;
}

export function MemberNewHireStepper(props: Props) {

	const { hideSteps, basePath, hideAll } = props;

	const app = useContext(DemographicsContext);

	const buttonClasses = buttonStyles();
	const classes = genericStepperStyles();
	const dispatch = useDispatch();
	const currentStep = useSelector<TcsmStates, NewHireEnrollmentStep>(state => state?.newHireEnrollmentState?.currentStep);
	const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const history = useHistory();
	const isNep = isNepEnrollment();
	const isScheduledHrIncrease = useSelector<TcsmStates, boolean>(state => !!state?.newHireEnrollmentState?.memberGhlEnrollments?.find(a => a.employment_id === state?.newHireEnrollmentState?.memberCurrentEmploymentId && a.qualifying_event === HoursIncreaseEventType));
	const employmentRecord = `${basePath}${NewHireEnrollmentRoutes.EmployeeRecord}${AccountInfoRoutes.PersonalInfoSegment}`;
	const benefitEnrollment = `${basePath}${NewHireEnrollmentRoutes.BenefitEnrollment}${isNep ? NewHireEnrollmentRoutes.Coverage : NewHireEnrollmentRoutes.Pension}`;

	const personState = useSelector<TcsmStates, PersonalInfoState>(state => state.personalInfo[app]);
	const labelSettings = useSelector<TcsmStates, LabelSettingProps>(a => a.epiProps?.labelSettingState?.epiContent);

	const onClick = (step: NewHireEnrollmentStep, url: string) => {
		dispatch(setCurrentNewHireEnrollmentStep(step));
		history.push(url);
	};


	if (hideAll) {
		return null;
	}
	return (
		<div className={`${classes.genericStepperContainer} generic-stepper-tabs`}>
			<Hidden mdDown>
				<div className='generic-stepper-tab-desktop'>

					{!hideSteps &&
						<div className='generic-stepper-tab-desktop-inner'>
							<button
								className='generic-stepper-tab-item'
								type='button'
								onClick={() => onClick(NewHireEnrollmentStep.EMPLOYEE_RECORD, employmentRecord)}
								disabled={currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD}
							>
								<span className={`${currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD ? 'h4-styled' : 'h4-alt'}`}>{settings?.employmentRecordStepName}</span>
							</button>

							<button
								className='generic-stepper-tab-item'
								type='button'
								onClick={() => onClick(NewHireEnrollmentStep.BENEFIT_ENROLLMENT, benefitEnrollment)}
								disabled={currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT}
							>
								<span className={`${currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT ? 'h4-styled' : 'h4-alt'}`}>{settings?.benefitEnrollmentStepName}</span>
							</button>

						</div>}

					<div className='progress-stepper-infobar'>
						<h3>{isScheduledHrIncrease ? settings?.memberScheduledHourEnrollmentTitle : settings?.memberEnrollmentTitle}</h3>
						<NameClientNumber client={personState.currentPerson} clientNumberLabel={labelSettings?.clientNumberLabel} />
					</div>
				</div>
			</Hidden >
			{/*Below is the Mobile Stepper with mobile infobar*/}
			< Hidden mdUp >
				<InfoBarWrapper>
					<div>
						<h3> {isScheduledHrIncrease ? settings?.memberScheduledHourEnrollmentTitle : settings?.memberEnrollmentTitle} </h3>
						<NameClientNumber client={personState.currentPerson} clientNumberLabel={labelSettings?.clientNumberLabel} />
					</div>
				</InfoBarWrapper>
				{
					!hideSteps &&
					<Tabs
						value={currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD ? 0 : 1}
						variant='scrollable'
						scrollButtons>

						<button
							className={buttonClasses.linkButton}
							type='button'
							onClick={() => onClick(NewHireEnrollmentStep.EMPLOYEE_RECORD, employmentRecord)}
							disabled={currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD}
						>
							<span className={`${currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD ? 'h4-styled' : 'h4-alt'}`}>{settings?.employmentRecordStepName}</span>
						</button>

						<button
							className={buttonClasses.linkButton}
							type='button'
							onClick={() => onClick(NewHireEnrollmentStep.BENEFIT_ENROLLMENT, benefitEnrollment)}
							disabled={currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT}
						>
							<span className={`${currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT ? 'h4-styled' : 'h4-alt'}`}>{settings?.benefitEnrollmentStepName}</span>
						</button>

					</Tabs>
				}
			</Hidden >
		</div >
	);

}

MemberNewHireStepper.defaultProps = {
	hideAll: false,
};